import { render, staticRenderFns } from "./passes.vue?vue&type=template&id=8dc26644&"
import script from "./passes.vue?vue&type=script&lang=js&"
export * from "./passes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports